export enum PathFragmentType
{
  ARRAY,
  OBJECT,
  LIST
}

export class PathFragment
{
  type:PathFragmentType;
  index:number;
  member:string;

  static asIndex( index:number )
  {
    let path = new PathFragment();
    path.index = index;
    path.type = PathFragmentType.ARRAY;

    return path;
  }

  static asListEntry( index:number )
  {
    let path = new PathFragment();
    path.index = index;
    path.type = PathFragmentType.LIST;

    return path;
  }
  
  static asMember( member:string )
  {
    let path = new PathFragment();
    path.member = member;
    path.type = PathFragmentType.OBJECT;

    return path;
  }

  toString()
  {
    return this.type === PathFragmentType.OBJECT ? this.member : ( this.index + "" );
  }
}

export class InspectorReference
{
  parent:InspectorReference;
  path:PathFragment[] = [];
}